import { chooseLocation, useCurrentLocation, useLocations } from '../lib/location';
import { useT } from '../lib/i18n';

/** Only shown with 2+ locations (plan 2.2): which location the calendar and Vandaag show. */
export function LocationSwitcher({ orgId, className = '', compact = false }: { orgId: string; className?: string; compact?: boolean }) {
  const t = useT();
  const locations = useLocations(orgId);
  const current = useCurrentLocation(orgId);
  if (!locations.data || locations.data.length < 2 || !current.data) return null;
  if (compact) {
    return (
      <select
        aria-label={t('loc.current')}
        value={current.data.id}
        onChange={(e) => chooseLocation(orgId, e.target.value)}
        className={`min-h-9 rounded-full border border-line bg-surface px-3 text-sm font-medium ${className}`}
      >
        {locations.data.map((l) => (
          <option key={l.id} value={l.id}>
            {l.name}
          </option>
        ))}
      </select>
    );
  }
  return (
    <label className={`flex flex-col gap-1 ${className}`}>
      <span className="eyebrow">{t('loc.current')}</span>
      <select
        value={current.data.id}
        onChange={(e) => chooseLocation(orgId, e.target.value)}
        className="min-h-10 rounded-[var(--radius-control)] border border-line bg-surface px-2 text-[15px] font-medium"
      >
        {locations.data.map((l) => (
          <option key={l.id} value={l.id}>
            {l.name}
          </option>
        ))}
      </select>
    </label>
  );
}
